import { render } from "./HelpLayout.vue?vue&type=template&id=4dbfc52a&scoped=true"
import script from "./HelpLayout.vue?vue&type=script&lang=js"
export * from "./HelpLayout.vue?vue&type=script&lang=js"

import "./HelpLayout.vue?vue&type=style&index=0&id=4dbfc52a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbfc52a"]])

export default __exports__